import { ICredentials, IEmailVerification, IPasswordResetCredentilas, IEmailSuccess, ICheckTokenUuidCredentials } from '../types/auth';
import { IUserDetail } from '../types/user';
import { HttpClient } from './service';
import Urls from './urls';

export const AuthApi = {
  loggedInUser(): Promise<IUserDetail> {
    return HttpClient.get<IUserDetail, null>(Urls.AuthUrls.loginPath)
  },

  login(credentials: ICredentials): Promise<IUserDetail> {
    return HttpClient.post<IUserDetail, ICredentials>(Urls.AuthUrls.loginPath, credentials)
  },

  logout(): Promise<null> {
    return HttpClient.post<null, null>(Urls.AuthUrls.logoutPath, null)
  },

  emailVerificationResetPwd(email: IEmailVerification): Promise<IEmailSuccess> {
    return HttpClient.post<IEmailSuccess, IEmailVerification>(Urls.AuthUrls.emailPassResetPath, email)
  },

  resetPassword(resetConf: IPasswordResetCredentilas): Promise<IPasswordResetCredentilas>  {
    return HttpClient.patch<IPasswordResetCredentilas, IPasswordResetCredentilas>(Urls.AuthUrls.resetPassword, null, resetConf)
  },

  checkResetToken(resetToken: ICheckTokenUuidCredentials): Promise<ICheckTokenUuidCredentials>  {
    return HttpClient.get<ICheckTokenUuidCredentials, null>(`${Urls.AuthUrls.checkToken}/${resetToken.uidb64}/${resetToken.token}/`, null)
  }
}
